import { useState } from "react";
import {
	type MenuItemProps,
	type MenuProps,
	Menu as PaperMenu,
} from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

type Props = MenuProps & {
	items: MenuItemProps[];
	density?: "high" | "medium" | "low";
	onItemPress: (item: MenuItemProps) => void;
};

const Menu = ({ items, density = "medium", onItemPress, ...props }: Props) => {
	const theme = useAppTheme();
	const [selectedItem, setSelectedItem] = useState<MenuItemProps | null>(null);
	const handleItemPress = (item: MenuItemProps) => {
		setSelectedItem(item);
		onItemPress(item);
	};
	return (
		<PaperMenu
			{...props}
			contentStyle={{
				backgroundColor: theme.colors.surfaceVariant,
			}}
		>
			{items.map((item) => (
				<PaperMenu.Item
					key={String(item.title)}
					{...item}
					theme={theme}
					style={{
						opacity: item.disabled ? 0.38 : 1,
						backgroundColor:
							selectedItem?.title === item.title
								? theme.colors.secondaryContainer
								: "transparent",
						paddingVertical:
							density === "high" ? 8 : density === "medium" ? 12 : 16,
					}}
					onPress={() => handleItemPress(item)}
				/>
			))}
		</PaperMenu>
	);
};

export default Menu;
